var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<section id=\"network-"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" class=\"network name-"
    + alias2(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/slugify.js")).call(alias3,(depth0 != null ? depth0.name : depth0),{"name":"slugify","hash":{},"data":data}))
    + " "
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.serverOptions : depth0)) != null ? stack1.NETWORK : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-nick=\""
    + alias2(alias1((depth0 != null ? depth0.nick : depth0), depth0))
    + "\" data-options=\""
    + alias2(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/tojson.js")).call(alias3,(depth0 != null ? depth0.serverOptions : depth0),{"name":"tojson","hash":{},"data":data}))
    + "\">\n"
    + ((stack1 = container.invokePartial(require("/home/travis/build/thelounge/lounge/client/views/chan.tpl"),depth0,{"name":"chan","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "network-"
    + container.escapeExpression(__default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/slugify.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.serverOptions : depth0)) != null ? stack1.NETWORK : stack1),{"name":"slugify","hash":{},"data":data}));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.networks : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/network.tpl
// module id = 241
// module chunks = 0